import { HelpersGroup } from "@monsma/XDL/types";

const when = (suffix: string, check: any, truly = "", falsy = "") => {
    return suffix === check ? truly : falsy;
};

const on = {
    center: (suffix: string) => when(suffix, "center", "align-items: center;justify-content: center;"),
    auto: (suffix: string) => when(suffix, "auto", "flex: 0 0 auto;"),
    grow: (suffix: string) => when(suffix, "auto", "flex: 1 0 auto;"),
};

const Fx = {
    // flex, flex-inline, flex-center, flex-auto
    flex: (props: any, suffix: string) =>
        `display:${when(suffix, "inline", "inline-flex", "flex")};flex-wrap: wrap;${on.center(suffix)}${on.auto(
            suffix,
        )};`,

    // row, row-reverse, ...flex: row-inline, row-center, row-auto
    row: (props: any, suffix: string) =>
        `${Fx.flex(props, suffix)}flex-direction: row;${when(suffix, "reverse", "flex-direction: row-reverse;")}`,

    // column, column-reverse, ...flex: column-inline, column-center, column-auto
    column: (props: any, suffix: string) =>
        `${Fx.flex(props, suffix)}flex-direction: column;${when(suffix, "reverse", "flex-direction: row-column;")}`,

    // wrap, wrap-reverse, noWrap
    wrap: (props: any, suffix: string) => `flex-wrap: wrap;${when(suffix, "reverse", "flex-wrap: wrap-reverse;")}`,
    noWrap: (props: any, suffix: string) => "flex-wrap: nowrap;",

    // order, order-first, order-last, order-15
    order: (props: any, suffix: string) => {
        switch (suffix) {
            case "first":
                return "order: -10000;";
            case "last":
                return "order: 10000;";
            default:
                return `order: ${+suffix || 0};`;
        }
    },

    // justify, justify-start, justify-end, justify-center, justify-around, justify-between
    justify: (props: any, suffix: string) => {
        switch (suffix) {
            case "start":
                return "justify-content: flex-start;";
            case "end":
                return "justify-content: flex-end;";
            case "center":
                return "justify-content: center;";
            case "around":
                return "justify-content: space-around;";
            case "between":
            default:
                return "justify-content: space-between;";
        }
    },

    // items, items-start, items-end, items-center, items-baseline, items-stretch
    items: (props: any, suffix: string) => {
        switch (suffix) {
            case "end":
                return "align-items: flex-end;";
            case "center":
                return "align-items: center;";
            case "baseline":
                return "align-items: baseline;";
            case "stretch":
                return "align-items: stretch;";
            case "start":
            default:
                return "align-items: flex-start;";
        }
    },

    // content, content-start, content-end, content-center, content-stretch, content-between, content-around
    content: (props: any, suffix: string) => {
        switch (suffix) {
            case "end":
                return "align-content: flex-end;";
            case "center":
                return "align-content: center;";
            case "stretch":
                return "align-content: stretch;";
            case "between":
                return "align-content: space-between;";
            case "around":
                return "align-content: space-around;";
            case "start":
            default:
                return "align-content: flex-start;";
        }
    },

    // self, self-start, self-end, self-center, self-baseline, self-stretch
    self: (props: any, suffix: string) => {
        switch (suffix) {
            case "end":
                return "align-self: flex-end;";
            case "center":
                return "align-self: center;";
            case "baseline":
                return "align-self: baseline;";
            case "stretch":
                return "align-self: stretch;";
            case "start":
            default:
                return "align-self: flex-start;";
        }
    },

    // col-[1-12]
    col: ({ columns }: any, suffix: string) => {
        let css =
            "height: auto;min-height: 0;max-height: 100%;width: auto;min-width: 0;max-width: 100%;flex: 10000 1 0%;";
        css += on.auto("auto");

        // TODO: way to apply col as column not only row
        return `${css} height: auto;width: ${(+suffix / columns) * 100}%;`;
    },
} as HelpersGroup;

export default Fx;
